import { useAppContext } from '../context';
import { UserAudio } from '../../@types';
import { useEffect } from 'react';
import { STATUS_REGISTRATION_REQUIREMENT } from '../../utils';

interface Props {
  clonedAudioData: UserAudio;
}

export const useClonedAudioCard = ({ clonedAudioData }: Props) => {
  const { id, userAudioSample } = clonedAudioData;

  const initialAudioStatus = userAudioSample?.[0]?.status ?? null;
  const initialUrlData = userAudioSample?.[0]?.uploads?.url ?? null;

  const {
    websocket: { isConnected, sendMessage, clonedAudioTaskMap },
  } = useAppContext();

  const clonedAudioTask = clonedAudioTaskMap.get(id) ?? null;
  const {
    status: taskStatus = null,
    progress: taskProgress = 0,
    data: { url = '' } = {},
  } = clonedAudioTask || {};

  const audioDataStatus = taskStatus || initialAudioStatus;
  const audioUrl = url || initialUrlData;
  const cardProgress = taskProgress;

  useEffect(() => {
    const { registrationRequired } = STATUS_REGISTRATION_REQUIREMENT;

    if (isConnected && registrationRequired.includes(audioDataStatus)) {
      sendMessage({
        event: 'register',
        data: { id },
      });
    }
  }, [isConnected, audioDataStatus, id, sendMessage]);

  return {
    audioDataStatus,
    audioUrl,
    cardProgress,
  };
};
